module.exports = __webpack_public_path__ + "img/t3-gold.52962132.jpg";